import { RegisterPartnerForm } from "Auth/Components/RegisterPartnerForm";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";

export const RegisterPartnerPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={t(Resources.SignUp.Title)}>
      <RegisterPartnerForm />
    </UnauthenticatedLayout>
  );
};
